export const formatNumber = (number) => {
  const formattedNumber = Math.floor(number).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedNumber;
};
